import { View } from "tamagui";

export const Highlight = ({
  children,
  width = 40,
  height = 40,
}: {
  children: React.ReactNode;
  width?: number;
  height?: number;
}) => {
  return (
    <View
      width={width}
      height={height}
      bg="#F7EAC4"
      py="$2"
      px="$3"
      borderRadius="$5"
      alignItems="center"
      justifyContent="center"
    >
      {children}
    </View>
  );
};
